module.exports = __webpack_public_path__ + "static/media/8-5.b2089c48.mp3";